"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

const SubmenuBottomAction = dynamic(
  async () => (await import("./SubmenuBottomAction")).SubmenuBottomAction
);

export const SubmenuBottomActionComponent: RegisteredComponent = {
  name: "SubmenuBottomAction",
  component: SubmenuBottomAction,
  defaultStyles: {
    marginTop: "0px",
  },
  inputs: [
    {
      name: "link",
      type: "object",
      subFields: [
        { name: "text", type: "string" },
        { name: "href", type: "url" },
      ],
      defaultValue: {
        text: "Learn more",
        href: "/",
      },
    },
    {
      name: "withCloseAction",
      type: "boolean",
      defaultValue: true,
    },
    {
      name: "buttonText",
      type: "string",
      defaultValue: "Close menu",
    },
  ],
};
